import { render, staticRenderFns } from "./receiptPrintSetting.vue?vue&type=template&id=12364dd8&scoped=true"
import script from "./receiptPrintSetting.vue?vue&type=script&lang=js"
export * from "./receiptPrintSetting.vue?vue&type=script&lang=js"
import style0 from "./receiptPrintSetting.vue?vue&type=style&index=0&id=12364dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12364dd8",
  null
  
)

export default component.exports